import { User } from "utils/api/client/pom-admin/user"
import { Customer } from "./customer"
import { Events } from "./events"
import { Experts } from "./experts"
import { Image } from "./image"
import { Posts } from "./posts"
import { Vendors } from "./vendors"
import { Widgets } from "./widgets"
import { Editorials } from "./editorials"
import { Specialties } from "./specialties"
import { IntegrationLogs } from "./integration-logs"

export class PomAdmin {
  customer: Customer
  user: User
  events: Events
  experts: Experts
  vendors: Vendors
  widgets: Widgets
  image: Image
  posts: Posts
  editorials: Editorials
  specialties: Specialties
  integrationLogs: IntegrationLogs

  constructor(client: unknown, _: unknown) {
    this.customer = new Customer(client)
    this.user = new User(client)
    this.events = new Events(client)
    this.experts = new Experts(client)
    this.vendors = new Vendors(client)
    this.widgets = new Widgets(client)
    this.image = new Image(client)
    this.posts = new Posts(client)
    this.editorials = new Editorials(client)
    this.specialties = new Specialties(client)
    this.integrationLogs = new IntegrationLogs(client)
  }
}
